import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  FormLabel,
  Heading,
  HStack,
  Image,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
  Textarea,
  VStack,
  Button,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  closeCreateAnnouncement,
} from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createAnnouncementRequest,
  editAnnouncementRequest,
} from "../../../../modules/admin-modules/announcements/Actions";
import { API } from "../../../../constants";

const AddAnnouncement = ({ isAdd, data, setSelectedData }) => {
  const openAnnouncement = useSelector((state) => state.model.isOpen39);
  const isLoading = useSelector((state) => state.announcements.isLoading);
  const [selected, setSelected] = useState(null);
  const baseUrl = API || "https://api.edutopiaonline.com/";

  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    watch,
  } = useForm({
    defaultValues: data ? data : { active: 1 },
    shouldUnregister: true,
  });

  const imageFile = watch("image");

  useEffect(() => {
    if (data && !isAdd) {
      reset(data);
      setValue("active", data.active);
    } else {
      reset({ active: 1 });
      setSelected(null);
    }
  }, [data, isAdd, reset, setValue]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة إعلان" : "تعديل إعلان"}
      </Heading>
    </Box>
  );

  const onSubmit = async (formData) => {
    let formDataObj = new FormData();
    
    // Append all fields except image if it's not a file
    for (let key in formData) {
      if (key !== "image") {
        formDataObj.append(key, formData[key]);
      }
    }

    // Handle image file
    if (imageFile && imageFile instanceof File) {
      formDataObj.append("image", imageFile);
    }

    // Ensure active is 0 or 1
    const activeValue = formData.active === "1" || formData.active === 1 ? 1 : 0;
    formDataObj.set("active", activeValue);

    const action = () => {
      dispatch(closeCreateAnnouncement());
      setSelectedData({});
      reset();
      setSelected(null);
    };

    if (isAdd) {
      await dispatch(createAnnouncementRequest(formDataObj, action));
    } else {
      formDataObj.append("_method", "PUT");
      await dispatch(
        editAnnouncementRequest({
          id: data?.id,
          formData: formDataObj,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateAnnouncement());
    setSelectedData({});
    reset();
    setSelected(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Validate file type
      const validTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!validTypes.includes(file.type)) {
        alert('يرجى اختيار صورة بصيغة jpeg, jpg, أو png');
        return;
      }
      setValue("image", file);
      setSelected(file.name);
    }
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openAnnouncement}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack dir="rtl" w="100%" alignItems="flex-start" spacing={4}>
          <Box w="100%">
            <MainInput
              label="العنوان"
              error={errors?.title?.message}
              placeholder=" اكتب عنوان الإعلان"
              register={register}
              name="title"
              required
            />
          </Box>

          <Box w="100%">
            <FormLabel>المحتوى:</FormLabel>
            <Textarea
              {...register("content", { required: "المحتوى مطلوب" })}
              placeholder="اكتب محتوى الإعلان"
              rows={6}
              bg="#f5f5f5"
              borderRadius="16px"
              border="none"
            />
            {errors?.content && (
              <Text color="red.500" fontSize="14px" mt="5px">
                {errors.content.message}
              </Text>
            )}
          </Box>

          <Box w="100%">
            <HStack w="100%" my="20px" justifyContent="space-between" dir="rtl">
              <HStack w="50%">
                <FormLabel>صورة الإعلان:</FormLabel>
                <Button
                  bg="main_1"
                  color="white"
                  borderRadius="8px"
                  textAlign="center"
                  position="relative"
                >
                  <Text>
                    {selected
                      ? selected
                      : data?.image
                        ? `file_1`
                        : "اختر ملف ليتم رفعه"}
                  </Text>
                  <Input
                    onChange={handleImageChange}
                    type="file"
                    accept="image/jpeg,image/jpg,image/png"
                    placeholder="اختر ملف ليتم رفعه"
                    opacity="0"
                    position="absolute"
                    w="100%"
                    h="100%"
                    cursor="pointer"
                  />
                </Button>
              </HStack>
              {data?.image && !imageFile && (
                <Image
                  src={`${baseUrl}${data.image}`}
                  alt={data.title}
                  maxW="200px"
                  maxH="200px"
                  objectFit="cover"
                />
              )}
            </HStack>
          </Box>

          <Box w="100%">
            <FormLabel>الحالة:</FormLabel>
            <RadioGroup
              defaultValue={data?.active !== undefined ? String(data.active) : "1"}
              onChange={(value) => setValue("active", parseInt(value))}
            >
              <Stack direction="row" spacing={4}>
                <Radio value="1" colorScheme="green">
                  نشط
                </Radio>
                <Radio value="0" colorScheme="red">
                  غير نشط
                </Radio>
              </Stack>
            </RadioGroup>
          </Box>
        </VStack>
      </form>
    </MainModel>
  );
};

export default AddAnnouncement;

